import { DashboardRouteModel } from "@/apidtos";
import { useCurrentUser } from "@core/hooks/useCurrentUser";

export const useDashboardLinks = () => {
  const { user } = useCurrentUser();
  return user?.DashboardRoutes;
};
